
export const PAYMENT_HOLIDAYS: readonly string[] = [
  '01/01/2025',
  '01/20/2025',
  '02/17/2025',
  '05/26/2025',
  '06/19/2025',
  '07/04/2025',
  '09/01/2025',
  '10/13/2025',
  '11/11/2025',
  '11/27/2025',
  '12/25/2025',
  '01/01/2026',
  '01/19/2026',
  '02/16/2026',
  '05/25/2026',
  '06/19/2026',
  '07/04/2026',
  '09/07/2026',
  '10/12/2026',
  '11/11/2026',
  '11/26/2026',
  '12/25/2026',
  '01/01/2027',
  '01/18/2027',
  '02/15/2027',
  '05/31/2027',
  '06/19/2027',
  '07/04/2027',
  '09/06/2027',
  '10/11/2027',
  '11/11/2027',
  '11/25/2027',
  '12/25/2027',
] as const;

export const MAX_ADDITIONAL_PRINCIPAL = 25000;

export const MAX_ADDITIONAL_ESCROW = 9999.99;

export const LATE_FEE_DATE = 16;
